import { useMemo, useEffect } from 'react';
import { actionCreators } from 'app/area/bowtie/actions';
import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectConnectedCasesByConnectionType } from 'app/area/bowtie/selectors';


function useActionCreators() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(actionCreators, dispatch), [dispatch]);
}

export function useConnectedCases(caseId: number, connectedCaseIds?: number[]) {
  const {
    loadConnectedCasesByConnectionType,
    updateBowtieInstance,
    validateCaseId
  } = useActionCreators();
  const instanceKey = useInstanceKey();
  const connectedCasesByConnectionType = useSelector(selectConnectedCasesByConnectionType(instanceKey, caseId));
  useEffect(() => {
    if (connectedCaseIds?.length && caseId) {
      loadConnectedCasesByConnectionType(caseId, connectedCaseIds, instanceKey);
    }
  }, [JSON.stringify(connectedCaseIds)]);
  return {
    connectedCasesByConnectionType,
    instanceKey,
    updateBowtieInstance,
    validateCaseId
  };
}
